import React, { useRef } from "react";
import PropTypes from "prop-types";
import Button from "../../components/buttons/Button";

import Container from "../../components/containers/Container";
import Overline from "../../components/Overline";
import RevealText from "../../components/RevealText";
import TextLink from "../../components/TextLink";

import { parseHeadline } from "../../utils/helpers";
import { Headline } from "../../components/containers/HeadlineContainers";
import { useVideo } from "../../components/hooks/useVideo";
import { navigateTo } from "../../components/LinkChoice";

const HeroImage = ({ content }) => {
  const { media, heroMedia } = content;
  const {
    overline,
    headline,
    linkAddressOne,
    linkAddressTwo,
    linkNameOne,
    linkNameTwo,
  } = heroMedia[0];
  const videoContainer = useRef();

  if (media[0].mimeType.includes("video")) {
    useVideo(
      videoContainer,
      media[0].mimeType.includes("video") ? media[0].url : null,
      true,
      "absolute z-0 top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 object-cover object-center h-full w-full",
      false
    );
  }

  return (
    <Container
      forwardedRef={videoContainer}
      className="min-h-screen flex items-end md:items-center"
    >
      {media[0].mimeType.includes("image") && (
        <img
          alt="hero"
          src={media[0].url}
          className="absolute z-0 top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 object-cover object-center h-full w-full"
        />
      )}
      <div className="text-white mb-28 md:mb-0 max-w-4xl relative z-10">
        <RevealText>
          <Overline
            size="normal"
            dotColor="bg-highlight"
            textColor="text-highlight"
            text={overline}
          />
        </RevealText>
        <Headline className="slides__caption-headline my-6 md:mb-8 font-black">
          {parseHeadline(headline).map((line) => (
            <RevealText key={line} text={line} />
          ))}
        </Headline>
        <RevealText>
          {linkNameOne && linkAddressOne && (
            <Button
              className="hidden md:block mr-6"
              label={linkNameOne}
              size="large"
              action={() => navigateTo(linkAddressOne)}
            />
          )}
          {linkNameTwo && linkAddressTwo && (
            <Button
              className="hidden md:block"
              variant="ghost"
              color="secondary"
              label={linkNameTwo}
              size="large"
              action={() => navigateTo(linkAddressTwo)}
            />
          )}
          {linkNameOne && linkAddressOne && (
            <TextLink
              className="md:hidden"
              text={linkNameOne}
              link={linkAddressOne}
            />
          )}
        </RevealText>
      </div>
    </Container>
  );
};

HeroImage.propTypes = {
  content: PropTypes.shape({
    media: PropTypes.array,
    heroMedia: PropTypes.arrayOf(
      PropTypes.shape({
        overline: PropTypes.string,
        headline: PropTypes.string,
        linkAddressOne: PropTypes.string,
        linkAddressTwo: PropTypes.string,
        linkNameOne: PropTypes.string,
        linkNameTwo: PropTypes.string,
      })
    ),
  }),
};

export default HeroImage;
